export let data = {
	gobARk: {
		name: 'go.bARk',
		description:
			"An Augmented Reality virtual pet game, built using the PERN (PostgreSQL, Express, React (and React Native), and Node.js) stack, and integrated with Viromedia’s ViroReact library. go.bARk comes equipped with three dogs to choose from and four finished dog/user interactions. \n\tOur goal with go.bARk was to create a fully functioning game that recreated the experience of some of our childhood favorite toys in a mobile application. We embraced the challenges of working with native applications, augmented reality, and multiplayer socket functionality. In the end, we created a project with a separately hosted back-end database that showcases the different experiences AR can provide. We also built out additional functionality that makes it easy to switch go.bARk's surface recognition to being a tabletop game using Pixi.js's raytracing capabilities.",
		linkOne: 'Github',
		linkOneUrl: 'https://github.com/gh-capstone-team-c/Go.bARk',
		linkTwo: 'Presentation',
		linkTwoUrl: 'https://www.youtube.com/watch?v=tJig6T0Ccoc',
	},
	promiseHS: {
		name: 'PromiseHS',
		description:
			'A 4-day hackathon-style sliding-ice-puzzle game built using React, Express.js, and Pixi.JS. The idea behind PromiseHS formed after a simplified, age-appropriate discussion of async/await with my daughter. Combined with some light humor and old-school RPG style mini-game functionality, PromiseHS was born.',
		linkOne: 'Github',
		linkOneUrl: 'https://github.com/leslie-meng/promiseHS',
		linkTwo: 'Live Site',
		linkTwoUrl: 'https://promise-hs.herokuapp.com/',
	},
	chai: {
		name: 'Chai Noon',
		description:
			'A mock e-commerce site selling tea products built with the PERN (PostgreSQL, Express, React, Node) Stack, Mocha, Redux, and Chai. From inception to creation, the project took nine days. Our group decided early on that we wanted to create a solid user experience whether the user was a guest or a logged in member. My favorite part of the project? Guest cart persistence & cart merge on login! ',
		linkOne: 'Github',
		linkOneUrl: 'https://github.com/grace-shopper-orgs/chai-noon',
		linkTwo: 'Live Site',
		linkTwoUrl: 'https://chai-noon.herokuapp.com/',
	},
	plants: {
		name: 'Plants',
		description:
			'Growing up, we were always surrounded by plants of different kinds. I have now picked up that mantle and am currently curating my own personal oasis, some of which have made their way onto this website. A healthy environment encourages inspiration!',
	},
	coffee: {
		name: 'Coffee',
		description:
			'Cold brew or pour-over are my go-to prep styles, but I love learning about different preparations, brews, vendors, grinds, you name it! Depth first approach, because knowing the process means a better understanding and appreciation of what it takes. I am a hobbyist coffee roaster, and a huge fan of mystery packs of regionally sourced green coffee beans.',
	},
	helloCard: {
		name: 'About Me',
		description:
			"Hello! I'm Leslie and I am a full stack software developer. My reason for becoming a dev was simple- I wanted to work with others to craft shared and persistent solutions. I am a big fan of continuous learning and communication. When I'm not programming, you can find me engaged in some of my other hobbies, like coffee, plants, exercise, baking, crafting, gaming, and reading.",
	},
	blueOcean: {
		name: 'Blue Ocean Strategy',
		description:
			'An interesting read about integrative approaches! I first heard about this book in 2011 during a lecture. Good concepts, and definitely something to aspire towards.',
		linkOne: 'Good Reads',
		linkOneUrl: 'https://www.goodreads.com/book/show/4898.Blue_Ocean_Strategy?',
	},
	bfa: {
		name: 'Bargaining for Advantage',
		description:
			'A personal favorite - this book was the first negotiation book I ever read. My favorite anecdote on integrative solutions is in this book!',
		linkOne: 'Good Reads',
		linkOneUrl:
			'https://www.goodreads.com/book/show/23801.Bargaining_for_Advantage?',
	},
	webtoons: {
		name: 'Webtoons',
		description:
			"My first long-format webcomic was Bongcheon-Dong Ghost by Horang. At the time I had never seen anything like it. If you haven't read it, I highly recommend the experience. No spoilers! Since then, I have read so many webtoons of all different genres and art styles. I'm particularly impressed by stories that have nuanced characters, stories that utilize different features on your phone, and stories where the characters either break the fourth wall or have no interest in the current plotline. Refreshing! \nSome titles: \n\t\tGourmet Hound, The Duchess's 50 Tea Recipes, Horang's Nightmare, Ghost Teller, I Don't Want This Kind of Hero, Tales of the Unusual, Odd Girl Out, Eleceed, Beware the Villainess, I Want to be You for a Day,  etc... etc... etc...",
		linkOne: 'Webtoons',
		linkOneUrl: 'https://www.webtoons.com/en/',
	},
	webnovel: {
		name: 'Web Novels',
		description:
			'Some of the best webtoons were originally webnovels, unsurprisingly. I have read a number of completed and ongoing stories. Some of them have been a lot of fun to read. The genres I have been reading most recently include isekais, reincarnation, intrigue, and revenge. One novel I enjoyed was The Villainess Turns the Hourglass, which was particular satisfying for its characterization. The main character is neither omniscient nor omnipotent, but has the cleverness to adjust her choices and take control of her fate. The dearth of unnecessary romance was also a huge plus.',
	},
	techStack: {
		name: 'Tech Stack',
		description: '/siteAssets/techstack.png',
	},
	tea: {
		name: 'Tea',
		description:
			"Growing up, tea was something that always sounded amazing but didn't particularly live up to it's smell or description. Until I started actually playing around with temperature and timing during brewing. Nowadays, I use another gadget to auto brew my teas for me! But this kettle is my go-to for pour-over coffees and larger batches of tea.",
	},
	novelCase: {
		name: 'Novel Case',
		description:
			'Novel Case is the small but driven development team behind this and other websites! Founded by Jackie Feit, Marie Crumpton, and me, this team has banked numerous hours dedicated to creating unique solutions for personal experiences.',
		linkOne: 'Github',
		linkOneUrl: 'https://github.com/NovelCase',
		linkTwo: 'Live Site',
		linkTwoUrl: 'https://novelcase.netlify.app/',
	},
	navDesk: {
		name: 'Navigation',
		description: '/siteAssets/instructionsDesktop.png',
	},
	navMobile: {
		name: 'Navigation',
		description: '/siteAssets/instructionsmobile.png',
	},
};
